import React from 'react';
import {Button, Grid, Typography, useTheme} from '@material-ui/core';
import StyledPaper from './shared/StyledPaper';
import {Alert} from '@material-ui/lab';
import styled from 'styled-components';

const DesktopGrid = styled(Grid)`
  ${props => props.theme.breakpoints.down('sm')} {
  display: none;
  }
  `;

const MobileGrid = styled(Grid)`
  ${props => props.theme.breakpoints.up('md')} {
    display: none;
  }
  `;

const StyledText = styled(Typography)`
  ${props => props.theme.breakpoints.up('sm')} {
  margin-bottom: 30px;
  }
  `;

/**
 * Rate completed (good variant)
 */
const RateCompleteGood = () => {
  const theme = useTheme();

  const links = [
    {name: 'vl.ru', url: 'https://www.vl.ru/vladlink'},
    {name: '2ip', url: 'https://2ip.ru/isp-reviews/Vladlink/'},
    {name: '101', url: 'https://101internet.ru/vladivostok/rating/vladlink'},
  ];

  const desktopButtons = links.map(item => {
    return (
        <Grid item xs={4}>
          <Button fullWidth={true}
                  variant={'contained'} disableElevation
                  href={item.url}
                  target="_blank"
                  color={'primary'}>
            {item.name}
          </Button>
        </Grid>
    );
  });

  const mobileButtons = links.map(item => {
    return (
        <MobileGrid theme={theme} container item xs={12}>
          <Button size={'large'} fullWidth={true}
                  href={item.url}
                  target="_blank"
                  variant={'contained'} color={'primary'}>
            {item.name}
          </Button>
        </MobileGrid>
    );
  });

  return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity={'success'} variant={'standard'}>
            Спасибо, что помогаете делать Владлинк лучше!
          </Alert>
        </Grid>

        <Grid container item xs={12}>
          <StyledPaper>
            <StyledText theme={theme} variant={'body1'}>
              Пожалуйста, оставьте отзыв о наших услугах на одном из
              порталов.
            </StyledText>

            <DesktopGrid container spacing={3} theme={theme}>
              {desktopButtons}
            </DesktopGrid>
          </StyledPaper>
        </Grid>
        {mobileButtons}
      </Grid>

  );
};

export default RateCompleteGood;
